import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step3 } from '../../../../shared/models/component-messages/mapaAT/step3';
import { CriterePondere } from '../models/CriterePondere';

@Component({
  selector: 'app-critere-pondere',
  templateUrl: './critere-pondere.component.html'
})
export class CriterePondereComponent implements OnInit {

  @Input() uid = '';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
  @Input() criterePondere: CriterePondere;

  public step3 = new Step3();

  constructor() { }

  public ngOnInit() { }

  getUid() {
    return this.uid + '_SepSep_CriterePondere';
  }
}
